<template>
    <v-select v-model="connector" :items="connectors" item-value="connector_id" item-text="name" :label="label|translate" :clearable="clearable">
    </v-select>
</template>

<script>
  import {getConnector} from "../helper";

  export default {
    name: 'ConnectorSelector',
    props: {
      value: Number,
        label: {type: String, default: "connector"},
        clearable: {type: Boolean, default: true},
    },
    watch: {
      value () {
        if(this.connector!==this.value){
          this.connector = this.value
        }
      },
      connector (newValue) {
        this.$emit('input', newValue)
      },
    },
    async beforeMount () {
        let df = await getConnector({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name
        })
        this.connectors = df['result']
    },
      mounted(){
          if (this.value) {
              this.connector = this.value
          }
      },
    data () {
      return {
        connector: null,
        connectors:[]
      }
    },
  }
</script>

<style scoped>

</style>
